import { PythonTopic } from '../../../../types/python-topic';
import { algoritmosListasExercises } from './exercises';

export const algoritmosListasTopic: PythonTopic = {
  id: 3,
  title: 'Algoritmos sobre listas y comprensión de listas',
  description: 'Aprende algoritmos avanzados para trabajar con listas y usa comprensión de listas para código más eficiente.',
  theory: `# Algoritmos sobre Listas y Comprensión de Listas

## ¿Qué aprenderás en esta sección?

Esta sección te introduce a:
1. **Debugger**: Herramientas para depurar código
2. **Iteradores de lista**: Formas avanzadas de iterar
3. **Comprensión de listas**: Sintaxis concisa y eficiente
4. **Objetos y referencias**: Entender cómo Python maneja objetos

## Comprensión de Listas

Las list comprehensions son una forma elegante y eficiente de crear listas:
- Sintaxis concisa
- Más legible que bucles tradicionales
- Mejor rendimiento en muchos casos

## Algoritmos Avanzados

Aprenderás:
- Algoritmos comunes para listas
- Optimización de código
- Entender referencias y objetos en Python

## Estructura de esta sección

Cada ejercicio incluye teoría expandida, ejemplos prácticos y ejercicios para que puedas practicar a tu propio ritmo.`,
  difficulty: 'intermediate',
  exercises: algoritmosListasExercises
};

